// Fase 7 · Páxina pública /impacto — bilingüe GL/ES
import i18n from "@/i18n";

const GL = {
  hero_kicker: "PROXECTO NEXTGENERATIONEU",
  hero_title: "Impacto NextGeneration",
  hero_sub: "Un ecosistema dixital ao servizo dos tres concellos da Mancomunidade do Salnés",
  hero_cta_platform: "Explora a plataforma",
  hero_cta_data: "Consulta os datos abertos",

  section_alive_kicker: "UN PROXECTO VIVO",
  section_alive_title: "Indicadores en tempo real",
  section_alive_sub: "Datos reais agregados desde as coleccións operativas. Sen cifras inventadas.",

  kpi_days_operational: "Días operativos",
  kpi_detecciones: "Deteccións IA procesadas",
  kpi_concellos: "Concellos integrados",
  kpi_habitantes: "Habitantes beneficiados",
  kpi_api_calls_30d: "Consultas API pública · 30 días",
  kpi_datasets: "Datasets públicos activos",
  kpi_incidencias_pct: "Incidencias resoltas (%)",
  kpi_reports: "Informes públicos xerados",
  kpi_orgs_30d: "Organizacións activas · 30 días",
  kpi_audit: "Eventos de auditoría totais",
  kpi_co2e_avoided: "CO₂e evitado (t)",

  timeline_kicker: "CRONOLOXÍA DE ENTREGA",
  timeline_title: "Seis fases entregadas",
  timeline_sub: "Do MVP institucional á produción operativa con selos verificables.",
  timeline_phase: "Fase {{n}}",
  timeline_completed_at: "Entregada",

  environ_kicker: "IMPACTO AMBIENTAL",
  environ_title: "Reducción efectiva de emisións",
  environ_sub: "Cuantificación conforme ISO 14064 e factores oficiais MITECO / IPCC.",
  environ_no_baseline: "Aínda non hai baseline vs. actual comparables. O KPI aparecerá cando se complete un ciclo de rollup con datos operativos reais.",
  environ_intensity: "Intensidade kg CO₂e por tonelada xestionada",

  transparency_kicker: "TRANSPARENCIA E REUTILIZACIÓN",
  transparency_title: "Datos abertos con trazabilidade completa",
  transparency_api_calls: "Consultas API pública · 30 días",
  transparency_top_datasets: "Top 3 datasets consultados",
  transparency_reports_sealed: "Informes selados HMAC-SHA256",
  transparency_view_stats: "Ver estatísticas completas",

  integrations_kicker: "SISTEMAS INTEGRADOS",
  integrations_title: "Ecosistema operativo",
  integrations_sub: "Saúde en tempo real das fontes de datos e integracións externas.",
  integrations_ok: "Operativo",
  integrations_degraded: "Con degradación",
  integrations_down: "Sen conexión",
  integrations_unknown: "Sen datos",

  financing_kicker: "FINANCIAMENTO E XUSTIFICACIÓN",
  financing_title: "NextGenerationEU · PRTR",
  financing_body: "Este proxecto forma parte do Plan de Recuperación, Transformación e Resiliencia (PRTR), financiado pola Unión Europea — NextGenerationEU, coa colaboración de SEGITTUR e operado pola Mancomunidade do Salnés en cooperación con Valoriza Servizos Medioambientais.",
  financing_link_transparency: "Ver transparencia institucional",
  financing_link_docs: "Documentación técnica",

  no_data: "—",
  loading: "Cargando indicadores…",
};

const ES = {
  hero_kicker: "PROYECTO NEXTGENERATIONEU",
  hero_title: "Impacto NextGeneration",
  hero_sub: "Un ecosistema digital al servicio de los tres municipios de la Mancomunidad do Salnés",
  hero_cta_platform: "Explora la plataforma",
  hero_cta_data: "Consulta los datos abiertos",

  section_alive_kicker: "UN PROYECTO VIVO",
  section_alive_title: "Indicadores en tiempo real",
  section_alive_sub: "Datos reales agregados desde las colecciones operativas. Sin cifras inventadas.",

  kpi_days_operational: "Días operativos",
  kpi_detecciones: "Detecciones IA procesadas",
  kpi_concellos: "Municipios integrados",
  kpi_habitantes: "Habitantes beneficiados",
  kpi_api_calls_30d: "Consultas API pública · 30 días",
  kpi_datasets: "Datasets públicos activos",
  kpi_incidencias_pct: "Incidencias resueltas (%)",
  kpi_reports: "Informes públicos generados",
  kpi_orgs_30d: "Organizaciones activas · 30 días",
  kpi_audit: "Eventos de auditoría totales",
  kpi_co2e_avoided: "CO₂e evitado (t)",

  timeline_kicker: "CRONOLOGÍA DE ENTREGA",
  timeline_title: "Seis fases entregadas",
  timeline_sub: "Del MVP institucional a la producción operativa con sellos verificables.",
  timeline_phase: "Fase {{n}}",
  timeline_completed_at: "Entregada",

  environ_kicker: "IMPACTO AMBIENTAL",
  environ_title: "Reducción efectiva de emisiones",
  environ_sub: "Cuantificación conforme ISO 14064 y factores oficiales MITECO / IPCC.",
  environ_no_baseline: "Aún no hay baseline vs. actual comparables. El KPI aparecerá cuando se complete un ciclo de rollup con datos operativos reales.",
  environ_intensity: "Intensidad kg CO₂e por tonelada gestionada",

  transparency_kicker: "TRANSPARENCIA Y REUTILIZACIÓN",
  transparency_title: "Datos abiertos con trazabilidad completa",
  transparency_api_calls: "Consultas API pública · 30 días",
  transparency_top_datasets: "Top 3 datasets consultados",
  transparency_reports_sealed: "Informes sellados HMAC-SHA256",
  transparency_view_stats: "Ver estadísticas completas",

  integrations_kicker: "SISTEMAS INTEGRADOS",
  integrations_title: "Ecosistema operativo",
  integrations_sub: "Salud en tiempo real de las fuentes de datos e integraciones externas.",
  integrations_ok: "Operativo",
  integrations_degraded: "Con degradación",
  integrations_down: "Sin conexión",
  integrations_unknown: "Sin datos",

  financing_kicker: "FINANCIACIÓN Y JUSTIFICACIÓN",
  financing_title: "NextGenerationEU · PRTR",
  financing_body: "Este proyecto forma parte del Plan de Recuperación, Transformación y Resiliencia (PRTR), financiado por la Unión Europea — NextGenerationEU, con la colaboración de SEGITTUR y operado por la Mancomunidad do Salnés en cooperación con Valoriza Servicios Medioambientales.",
  financing_link_transparency: "Ver transparencia institucional",
  financing_link_docs: "Documentación técnica",

  no_data: "—",
  loading: "Cargando indicadores…",
};

i18n.addResourceBundle("gl", "common", { fase7: GL }, true, true);
i18n.addResourceBundle("es", "common", { fase7: ES }, true, true);

export default {};
